<div id="toast-wrapper" class="d-flex align-items-center gap-2 toast-wrapper position-fixed bg-dark p-2">
    <img *ngIf="statusType === 'error'" src="../../../assets/images/warning-error.svg" alt="" srcset="">
    <img *ngIf="statusType === 'success'" src="../../../assets/images/check mark-circle.svg" alt="" srcset="">
    <p class="text-para text-white">{{ statusMessage }}</p>
</div>
